import React from 'react';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import DataTable from '../../shared/component/dataTable/DataTable';
import PurchaseRequisitionColumn from '../../shared/component/dataTable/columns/PurchaseRequisitionColumn.json';
import {Button} from 'reactstrap';
import GeneralUtils from '../../shared/utils/GeneralUtils';
import AvField from '../../shared/component/form/AvField';
import {PURCHASE_REQUISITION_APPROVAL_FILTER, PURCHASE_REQUISITION_STATUS} from '../../shared/utils/Constants';
import '../../shared/styles/SettingsPage.css';

export default class PurchaseRequisition extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            requisitionStatus: 'OPEN',
            approvedFilter: 'false'
        };
        this.refDataTable = null;
    }

    componentDidMount() {
        if (GeneralUtils.isMobile()) {
            window.location.href = '#purchaseRequisitionMobile';
        }
    }

    setDataTableRef = (elem) => {
        this.refDataTable = elem;
        if (elem) {
            this.refreshDataTable();
        }
    };

    getListFields = () => {
        const showApproval = this.state.requisitionStatus === 'DELIVERY_NOTE';
        return PurchaseRequisitionColumn.fields.map(field => {
            if (field.field === 'approvalDisplay') {
                return {...field, visible: showApproval};
            }
            return field;
        });
    };

    render() {
        if (GeneralUtils.isMobile()) {
            return null;
        }

        const showApprovalFilter = this.state.requisitionStatus === 'DELIVERY_NOTE';

        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        <div className="settings-page__header">
                            <h1 className="settings-page__title">Purchase Requisition</h1>
                        </div>
                        <div className="settings-page__panel">
                            <div className="settings-page__invoice-toolbar">
                                <div className="settings-page__invoice-toolbar-status">
                                    <AvGroup className="mb-0">
                                        <AvField
                                            type="select"
                                            className="form-control"
                                            name="requisitionStatus"
                                            value={this.state.requisitionStatus}
                                            onChange={this.__handleChange}
                                        >
                                            {PURCHASE_REQUISITION_STATUS.map(element => (
                                                <option value={element.value} key={element.value}>
                                                    {element.name}
                                                </option>
                                            ))}
                                        </AvField>
                                    </AvGroup>
                                    {showApprovalFilter &&
                                        <AvGroup className="mb-0">
                                            <AvField
                                                type="select"
                                                className="form-control"
                                                name="approvedFilter"
                                                value={this.state.approvedFilter}
                                                onChange={this.__handleApprovalFilterChange}
                                            >
                                                {PURCHASE_REQUISITION_APPROVAL_FILTER.map(element => (
                                                    <option value={element.value} key={element.name}>
                                                        {element.name}
                                                    </option>
                                                ))}
                                            </AvField>
                                        </AvGroup>
                                    }
                                </div>
                            </div>

                            <div className="settings-page__toolbar settings-page__toolbar--start settings-page__toolbar--equal-height">
                                <Button
                                    color="outline-primary"
                                    className="settings-page__btn--add"
                                    style={{minWidth: '16.5rem'}}
                                    onClick={this.addNew}
                                >
                                    <i className="pi pi-plus" aria-hidden="true"/>
                                    Create Purchase Requisition
                                </Button>
                                <Button
                                    color="outline-primary"
                                    className="settings-page__btn--add"
                                    style={{minWidth: '14rem'}}
                                    onClick={this.addNewDeliveryNote}
                                >
                                    <i className="pi pi-plus" aria-hidden="true"/>
                                    Create Delivery Note
                                </Button>
                            </div>

                            <div className="settings-page__table-wrap">
                                <DataTable
                                    ref={this.setDataTableRef}
                                    fields={this.getListFields()}
                                    objectName={PurchaseRequisitionColumn.name}
                                    dataURL="inventory/PurchaseRequisition/all"
                                    rows={20}
                                    autoLoad={false}
                                    selectionMode="single"
                                    onDataSelect={this.onDataSelect}
                                />
                            </div>
                        </div>
                    </div>
                </AvForm>
            </div>
        );
    }

    refreshDataTable = () => {
        const table = this.refDataTable;
        if (!table || typeof table.findAll !== 'function') {
            return;
        }
        const {requisitionStatus, approvedFilter} = this.state;
        const filter = [
            {
                name: 'requisitionStatus',
                value: requisitionStatus,
                type: 'string',
                filterMatchMode: 'equals'
            }
        ];
        const filterElement = {requisitionStatus};
        if (requisitionStatus === 'DELIVERY_NOTE' && approvedFilter !== '') {
            // softrame: boolean equals must use type=select + subType=boolean (avoids lower() on BOOL)
            filter.push({
                name: 'approved',
                value: approvedFilter,
                type: 'select',
                subType: 'boolean',
                filterMatchMode: 'equals'
            });
            filterElement.approved = approvedFilter;
        }

        table.setState({filter, filterElement, first: 0, loading: true});
        const gridModel = {
            filter,
            sort: table.state.sort || [],
            pageNumber: 0,
            limit: table.state.rows
        };
        table.findAll(gridModel).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                table.setState({
                    data: response.data,
                    totalRecords: response.totalCount != null ? response.totalCount : 0,
                    loading: false
                });
            } else {
                table.setState({loading: false});
            }
        }).catch(() => table.setState({loading: false}));
    };

    onDataSelect = (data) => {
        if (data?.id) {
            window.location.href = '#purchaseRequisitionSave?' + data.id;
        }
    };

    addNew = () => {
        window.location.href = '#purchaseRequisitionSave?-1';
    };

    addNewDeliveryNote = () => {
        window.location.href = '#purchaseRequisitionSave?-1&mode=delivery';
    };

    __handleChange = (e) => {
        const value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({
            requisitionStatus: value,
            approvedFilter: value === 'DELIVERY_NOTE' ? 'false' : this.state.approvedFilter
        }, () => this.refreshDataTable());
    };

    __handleApprovalFilterChange = (e) => {
        const value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({approvedFilter: value}, () => this.refreshDataTable());
    };
}
